export interface Country {
  code: string;
  name: string;
  /** Example VAT ID, shown as placeholder/hint where a UST-ID is required. */
  vatIdExample: string;
}

/**
 * Countries a company can be based in. Must stay in sync with ALLOWED_COUNTRIES
 * in the backend (src/backend/schemas.py) — the backend rejects anything else.
 */
export const COUNTRIES: Country[] = [
  { code: 'DE', name: 'Deutschland', vatIdExample: 'DE123456789' },
  { code: 'AT', name: 'Österreich', vatIdExample: 'ATU12345678' },
  { code: 'IT', name: 'Italien', vatIdExample: 'IT12345678901' },
];

export const DEFAULT_COUNTRY_CODE = 'DE';

export function getCountryName(code: string | null | undefined): string {
  if (!code) return '';
  return COUNTRIES.find((c) => c.code === code)?.name ?? code;
}

/**
 * Whether a company billed in this country needs a UST-ID on its invoices.
 * Schenkwerk invoices from Germany, so every other country is cross-border
 * EU B2B (reverse charge) and requires the recipient's VAT ID.
 */
export function requiresVatId(code: string | null | undefined): boolean {
  return !!code && code !== DEFAULT_COUNTRY_CODE;
}
